import { baseURL, useGetQuery } from "api/config";

const API = {
  ABOUT_US_DESC: `${baseURL}/api/about-us-description`,
};

export const useAboutUsDesc = () => useGetQuery("ABOUT_US_DESC", API.ABOUT_US_DESC);
